import React from "react";

const CardWrapper = ({ children }) => {
  return <div className="cardwrapper">{children}</div>;
};

export default CardWrapper;
